/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { ComponentPropsWithoutRef, FC } from "react";

import cn from "classnames";

type Props = ComponentPropsWithoutRef<"svg"> & {
  size?: "lg" | "sm";
};

const ArrowRight: FC<Props> = ({
  className = "text-white",
  size = "lg",
  ...args
}) => {
  let sizeClassName;
  if (size === "lg") {
    sizeClassName = "w-16 h-16";
  } else {
    sizeClassName = "w-4 h-4";
  }

  return (
    <span test-id="Rt2ywqEw">
      <svg
        fill="currentColor"
        className={cn(className, sizeClassName)}
        viewBox="0 0 16 16"
        {...args}
        test-id="Wz49oGBJ"
      >
        <path
          fillRule="evenodd"
          d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
          test-id="j0T4t7wG"
        />
      </svg>
    </span>
  );
};

export default ArrowRight;
